import { encryptObject } from "@/helpers/noncehelper";
import { appendStoreIdToItems } from "@/helpers/storageHelper";
import { deleteManagementList, duplicateManagementList, fetchManagementList, getListItems, getManagementListItems, insertManagementList, renameManagementList, SortManagementList, updateListItems } from "@/services/products";
import { fetchSafeJson } from "@/utils/apiResponse";
import { Meta } from "@/utils/types/manageList";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchProductCategories = createAsyncThunk(
  "get_manage_lists",
  async (payload: {isActive: boolean, isFavourite: boolean, userToken: string, storeId: string }, { rejectWithValue }) => {
    const {userToken , ...rest} = payload;
    
    const data = await fetchManagementList(
      // "/productsManagement/fetchList",
      encryptObject(payload),
    );
    const safeJson = await fetchSafeJson(data)
    if(safeJson?.status != 400){
      const modifiedJsonData = {
          ...safeJson.response,
          cartListData: {
            ...safeJson.response?.cartListData,
            items: await appendStoreIdToItems(safeJson.response?.cartListData?.items, payload.storeId ),
          },
          getListData:    await Promise.all( safeJson.response?.getListData.map( (list: { items: { item_id: string; }[]; }) => ({
              ...list,
              items: appendStoreIdToItems(list?.items, payload.storeId),
            }))),
      };
      if(modifiedJsonData){
        return modifiedJsonData
      }
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details
      );
    }
  }
);

export const addProductCategories = createAsyncThunk(
  "insert_list",
  async (payload: { user_id: string | null; name: string, userToken: string }, { rejectWithValue }) => {
    const {userToken , ...rest} = payload;
    const data = await insertManagementList(encryptObject(payload));
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details

      );
    }
  }
);

export const deleteProductCategories = createAsyncThunk(
  "delete_managelist",
  async (payload: { id: number , userToken: string}, { rejectWithValue }) => {
    const {userToken , ...rest} = payload;
    const data = await deleteManagementList(
      encryptObject(payload)
    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details

      );
    }
  }
);

export const renameProductCategories = createAsyncThunk(
  "rename_managelist",
  async (payload: { name: string; id: number, userToken: string }, { rejectWithValue }) => {
    const {userToken , ...rest} = payload;
    const data = await renameManagementList(
      encryptObject(payload)
    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details

      );
    }
   
  }
);

export const duplicateProductCategories = createAsyncThunk(
  "duplicate_managelist",
  async (payload: { id: number; name: string; userToken: string, storeId: string }, { rejectWithValue }) => {
    const {userToken , ...rest} = payload;
    const data = await duplicateManagementList(
      encryptObject(payload)
    );
    
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      const modifiedJsonData = {
        data: {
          ...safeJson.response?.data,
        },
        items:  await appendStoreIdToItems(safeJson.response?.items, payload.storeId ),

      }
      if(modifiedJsonData){
        return modifiedJsonData
      }
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details

      );
    }
  }
);

// export const bulkInsertionProductCategories = createAsyncThunk(
//   "insert_all_managelist",
//   async (payload: { listArray: [] }, { rejectWithValue }) => {
//     // const {userToken , ...rest} = payload;
//     const data = await fetchManagementList(
//       "/api/productsManagement/bulkInsertion",
//       // encryptObject(rest)
//     );
//     // return data;
//     if(data?.status != 400){
//       return data;
//     }else {
//       return rejectWithValue(
//         data?.details?.details
//       );
//     }
//   }
// );

export const getListItemsAction = createAsyncThunk(
  "api/productsManagement/getListData",
  async (payload: {categoryId: string | number, userToken: string,storeId:string | number  }, { rejectWithValue }) => {
    const {userToken , ...rest} = payload
    const data = await getManagementListItems(
      encryptObject(payload)
    );
    
      const safeJson = await fetchSafeJson(data);
      if(safeJson.response?.status != 400){
        const modifiedJsonData = {
          data: {
            ...safeJson.response?.data,
            items:  await appendStoreIdToItems(safeJson.response?.data?.items, payload.storeId ),
       }
      }
      if(modifiedJsonData){
        return modifiedJsonData
      }
      // return safeJson.response;
    }
    else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);


// export const updateCustomList = createAsyncThunk(
//   "update_liststatus",
//   async (payload: {
//     itemId: string | number | undefined;
//     quantity: string | number | undefined;
//     itemName: object | undefined;
//   }, { rejectWithValue }) => {
//     const reqPayload = encrypt(payload);
//     const data = await fetchManagementList(
//       "/productsManagement/getListItem",
//       reqPayload,

//     );
   
//     const safeJson = await fetchSafeJson(data);
//     if(safeJson.response?.status != 400){
//       return safeJson.response;
//     }else {
//       return rejectWithValue(
//         safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
//       );
//     }
//   }
// );

// export const deleteCustomList = createAsyncThunk(
//   "delete_shoppinglist",
//   async (payload: { id: number }, { rejectWithValue }) => {
//     const reqPayload = encrypt(payload);
//     const data = await fetchManagementList(
//       "/productsManagement/deleteCustomList",
//       reqPayload
//     );
//     // return data;
//     if(data?.status != 400){
//       return data;
//     }else {
//       return rejectWithValue(
//         data?.details?.details
//       );
//     }
//   }
// );

// export const addAllCustomList = createAsyncThunk(
//   "insert_all_shoppinglist",
//   async (payload: { listArray: any[] }, { rejectWithValue }) => {
//     const reqPayload = encrypt(payload);
//     const data = await fetchManagementList(
//       "/productsManagement/bulkInsertionCustomList",
//       reqPayload
//     );
//     // return data;
//     if(data?.status != 400){
//       return data;
//     }else {
//       return rejectWithValue(
//         data?.details?.details
//       );
//     }
//   }
// );

// export const updateShoppedItem = createAsyncThunk(
//   "update_shopped_status",
//   async (payload: { id: string }, { rejectWithValue }) => {
//     const reqPayload = encrypt(payload);
//     const data = await fetchManagementList(
//       "/productsManagement/shoppedItem",
//       reqPayload
//     );
//     // return data;
//     if(data?.status != 400){
//       return data;
//     }else {
//       return rejectWithValue(
//         data?.details?.details
//       );
//     }
//   }
// );


export const updateListActiveStatus = createAsyncThunk(
  "managelist_status",
  async (payload: { id: number, userToken: string }, { rejectWithValue }) => {
    const {userToken , ...rest} = payload
    const data = await updateListItems(
      encryptObject(payload),
    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);

export const updateSortingType = createAsyncThunk(
  "sorting_option",
  async (payload: {
    id: number;
    sortingType: string;
    userToken: string;
  }, { rejectWithValue }) => {
    const {userToken , ...rest} = payload;
    const data = await SortManagementList(
      encryptObject(payload),

    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);